import {getRcnPeriodEndDate} from "./format_rcn_period_label";

interface IGetPeriodOfferPriceM2Params<T extends {date: string}> {
    history: T[] | null;
    periodStart: string;
    periodLabel: string;
    getPriceM2: (row: T) => number | null;
    getWeight?: (row: T) => number;
    /** Scopes `history` down to one city/district when it holds more than one - skip when `history` is already scoped. */
    filter?: (row: T) => boolean;
}

/**
 * Average offer price over the months a period spans, weighted by each month's offer count (equal weight
 * without `getWeight`) - same as the country-wide averages. Null when the period is outside the history.
 */
export const getPeriodOfferPriceM2 = <T extends {date: string}>(params: IGetPeriodOfferPriceM2Params<T>): number | null => {
    const {history, periodStart, periodLabel, getPriceM2, getWeight, filter} = params;

    if (!history || history.length === 0) {
        return null;
    }

    const periodEnd = getRcnPeriodEndDate(periodStart, periodLabel);

    if (!periodEnd) {
        return null;
    }

    const monthsInPeriod = history.filter((row) => (!filter || filter(row)) && row.date >= periodStart && row.date <= periodEnd);

    let weightedSum = 0;
    let weight = 0;

    for (const month of monthsInPeriod) {
        const priceM2 = Number(getPriceM2(month));

        if (!(priceM2 > 0)) {
            continue;
        }

        const rawWeight = getWeight ? Number(getWeight(month)) : 1;
        const monthWeight = rawWeight > 0 ? rawWeight : 1;

        weightedSum += priceM2 * monthWeight;
        weight += monthWeight;
    }

    return weight > 0 ? weightedSum / weight : null;
};
import {getRcnPeriodEndDate} from "./format_rcn_period_label";

interface IGetPeriodOfferPriceM2Params<T extends {date: string}> {
    history: T[] | null;
    periodStart: string;
    periodLabel: string;
    getPriceM2: (row: T) => number | null;
    getWeight?: (row: T) => number;
    /** Scopes `history` down to one city/district when it holds more than one - skip when `history` is already scoped. */
    filter?: (row: T) => boolean;
}

/**
 * Average offer price over the months a period spans, weighted by each month's offer count (equal weight
 * without `getWeight`) - same as the country-wide averages. Null when the period is outside the history.
 */
export const getPeriodOfferPriceM2 = <T extends {date: string}>(params: IGetPeriodOfferPriceM2Params<T>): number | null => {
    const {history, periodStart, periodLabel, getPriceM2, getWeight, filter} = params;

    if (!history || history.length === 0) {
        return null;
    }

    const periodEnd = getRcnPeriodEndDate(periodStart, periodLabel);

    if (!periodEnd) {
        return null;
    }

    const monthsInPeriod = history.filter((row) => (!filter || filter(row)) && row.date >= periodStart && row.date <= periodEnd);

    let weightedSum = 0;
    let weight = 0;

    for (const month of monthsInPeriod) {
        const priceM2 = Number(getPriceM2(month));

        if (!(priceM2 > 0)) {
            continue;
        }

        const rawWeight = getWeight ? Number(getWeight(month)) : 1;
        const monthWeight = rawWeight > 0 ? rawWeight : 1;

        weightedSum += priceM2 * monthWeight;
        weight += monthWeight;
    }

    return weight > 0 ? weightedSum / weight : null;
};
